import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {FormattedMessage} from 'react-intl';
import * as staticComponents from './staticComponents';
import styles from './signUpConsent.scss';

@CSSModules(styles, {allowMultiple: true})
class SignUpConsent extends React.Component {

  static propTypes = {
    buttonConfirmText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
  };

  render() {
    const {buttonConfirmText} = this.props;

    const signUpConsentTextValues = {
      privacyPolicy: staticComponents.privacyPolicyLink,
      termsOfUse: staticComponents.termsOfUseLink,
      buttonConfirmText
    };

    return (
      <div styleName="signUpConsent">
        <FormattedMessage id="registration.signUp.consent.text" values={signUpConsentTextValues}/>
      </div>
    );
  }
}

export default SignUpConsent;



// WEBPACK FOOTER //
// ./src/auth/SignUpConsent.js